/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ConsentSummary {
  granted?: number;
  declined?: number;
  withdrawn?: number;
  pending?: number;
  not_required?: number;
  not_collected?: number;
}
